<template>
  <ts-panel>
    <ts-panel-wrapper class="tw-space-y-2">
      <div class="row tw-space-y-4">
        <div class="col-md-12">
          <label class="form-label col-form-label col-md-12">{{
            $t("search")
          }}</label>
          <div class="col-md-12">
            <input type="text" v-model="search" class="form-control" />
          </div>
        </div>
        <h1 class="section-divider-underline">
          {{ $t("levelSkillSubject.levelSkillSubject") }}
        </h1>
        <div
          class="tw-overflow-auto col-12 tw-max-h-screen"
          style="height: 600px"
        >
          <table class="tw-w-full">
            <thead>
              <tr
                class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
              >
                <th class="tw-pl-2 tw-whitespace-nowrap" style="width: 15%">
                  {{ $t("levelSkillSubject.subjectCode") }}
                </th>
                <th class="tw-pl-2 tw-whitespace-nowrap" style="width: 30%">
                  {{ $t("levelSkillSubject.nameEN") }}
                </th>
                <th class="tw-pl-2 tw-whitespace-nowrap" style="width: 30%">
                  {{ $t("levelSkillSubject.nameKH") }}
                </th>
                <th style="width: 15%" class="tw-whitespace-nowrap required">
                  {{ $t("levelSkillSubject.subjectType") }}
                </th>
                <th style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(levelSkillSubject, index) in levelSkillSubjects"
                :key="index"
                class="tw-w-full tw-h-10"
              >
                <td class="tw-whitespace-nowrap tw-pl-2">
                  {{ levelSkillSubject.subject_code }}
                </td>
                <td class="tw-pl-2">
                  {{ levelSkillSubject.subject_name_en }}
                </td>
                <td class="tw-pl-2">
                  {{ levelSkillSubject.subject_name_kh }}
                </td>
                <td class="tw-whitespace-nowrap">
                  <select
                    v-model.number.trim="levelSkillSubject.subject_type_id"
                    class="form-select"
                    style="width: 100px"
                    :class="{
                      'is-invalid': errors.has(
                        'level_skill_subjects.' + index + '.subject_type_id'
                      ),
                    }"
                  >
                    <option
                      :value="null"
                      selected
                      disabled
                      style="display: none"
                    >
                      {{ $t("select") }}
                    </option>
                    <option value="1">Basic</option>
                    <option value="2">Core</option>
                  </select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('sector_profile_id')"
                  >
                    {{ errors.first("sector_profile_id") }}
                  </div>
                </td>
                <td
                  class="
                    tw-whitespace-nowrap
                    tw-text-red-500
                    tw-text-center
                    tw-cursor-pointer
                    hover:tw-bg-gray-300
                  "
                  @click="removeRow(levelSkillSubject)"
                >
                  <a-icon type="minus-circle" class="tw-text-lg" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ts-panel-wrapper>
  </ts-panel>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
  name: "evaluation",
  props: ["value", "validation"],
  data() {
    return {
      search: "",
      model: {},
      errors: new Errors(),
      options: null,
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("academic/levelSkillSubject", ["formViewDatas", "edit_data"]),
    levelSkillSubjects() {
      return this.model.level_skill_subjects
        .filter(
          (lsub) =>
            this.search
              .split(" ")
              .every((s) =>
                lsub.subject_name_en.toLowerCase().includes(s.toLowerCase())
              ) ||
            this.search
              .split(" ")
              .every((s) =>
                lsub.subject_code.toLowerCase().includes(s.toLowerCase())
              )
        )
        .slice(0, 400);
    },
  },
  methods: {
    removeRow(levelSkillSubject) {
      this.formViewDatas["subjects"].push({
        subject_profile_id: levelSkillSubject.subject_profile_id,
        subject_code: levelSkillSubject.subject_code,
        subject_name_en: levelSkillSubject.subject_name_en,
        subject_name_kh: levelSkillSubject.subject_name_kh,
      });

      this.formViewDatas["levelSkillSubjects"] = this.formViewDatas[
        "levelSkillSubjects"
      ].filter(function (i) {
        return i.subject_profile_id != levelSkillSubject.subject_profile_id;
      });

      this.model.level_skill_subjects.splice(
        this.model.level_skill_subjects.indexOf(levelSkillSubject),
        1
      );
    },
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
